import api from "./axios";

// Przykład funkcji do wysyłania searcha:
export async function searchFakturowniaClients(fields: Record<string, string>) {
  // Wytnij puste wartości
  const params = Object.fromEntries(
    Object.entries(fields).filter(([_, v]) => v && v.trim() !== "")
  );
  // Wysyłka tylko jeśli coś wpisane
  const query = new URLSearchParams(params).toString();
  if (!query) return []; // opcjonalnie: nie wysyłaj, jeśli wszystkie pola puste
  const res = await api.get(`/fakturownia-clients?${query}`);
  return res.data;
}
